import {useRef} from 'react';

type KanbanColumnPropsT<T = any> = {
  column: {
    id: string;
    title: string;
    items: T[];
  };
  isDark: boolean;
  CustomTaskComponent?: React.ComponentType<{
    item: T;
    isDark?: boolean;
  }>;
};

function KanbanColumn<T>({column, isDark, CustomTaskComponent}: KanbanColumnPropsT<T>) {
  const columnRef = useRef<HTMLDivElement>(null);

  return (
    <div
      style={{
        borderRadius: '5px',
        maxHeight: '100vh',
      }}
      className={`kanban-tasks-type flex flex-col p-2 ${isDark ? 'bg-bodybg' : 'bg-bodybg2'}`}
    >
      <div className="mb-4">
        <div className="flex items-center justify-between">
          <span className="block text-[.9375rem] font-semibold">
            {column.title} - {column.items.length}
          </span>
        </div>
      </div>
      <div className="kanban-tasks flex-1 overflow-auto" id={`${column.id}-tasks`}>
        <div ref={columnRef} className="firstdrag" data-view-btn={`${column.id}-tasks`}>
          {column.items.length === 0 ? (
            <div className="py-4 text-center text-gray-500">No items found</div>
          ) : (
            column.items.map((item, index) => (
              <div key={index}>{CustomTaskComponent && <CustomTaskComponent item={item} isDark={isDark} />}</div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default KanbanColumn;
